import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Box, IconButton, Paper, Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import ActiveFilters from "./ActiveFilters";
import { PacakgeNameFilter } from "./PacakgeNameFilter";
import { PackageRegionFilter } from "./PackageRegionFilter";
import PopularFilters from "./PopularFilters";
import TagFiltersMenu from "./TagFiltersMenu";

const PackageKindTooltip = () => (
  <Box sx={{ maxWidth: 320, p: 0.5 }}>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
      Pakiety główne
    </Typography>
    <Typography variant="body2" sx={{ mb: 1.5, opacity: 0.95 }}>
      Gotowe propozycje wycieczek — konkretne trasy i programy skonstruowane jako pełna oferta B2B.
    </Typography>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
      Wszystkie pakiety
    </Typography>
    <Typography variant="body2" sx={{ opacity: 0.95 }}>
      Pełna lista, w tym warianty pakietów głównych. Warianty mogą różnić się kolejnością punktów programu, szczegółami
      lub atrakcjami, ale bazują na pakiecie głównym.
    </Typography>
  </Box>
);

export function PackagesFilter(props: {
  filteredPackages: number;
  onlyParentPackages: boolean;
  onlyEcommercePackages: boolean;
  setOnlyParentPackages: (onlyParentPackages: boolean) => void;
  setOnlyEcommercePackages: (onlyEcommercePackages: boolean) => void;
}) {
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: 1.5,
          mb: 2,
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.08)",
          bgcolor: "rgba(255,255,255,0.9)",
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1.5}
          sx={{ alignItems: { xs: "stretch", md: "center" } }}
        >
          <PacakgeNameFilter paramName="name" />
          <Stack direction="row" spacing={0.75} sx={{ flexShrink: 0, alignItems: "center" }}>
            <ToggleButtonGroup
              exclusive
              size="small"
              value={props.onlyParentPackages}
              onChange={(_, value) => {
                if (value !== null) {
                  props.setOnlyParentPackages(value);
                }
              }}
              sx={{
                bgcolor: "rgba(0,0,0,0.02)",
                "& .MuiToggleButton-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  px: 1.5,
                  py: 0.5,
                  fontSize: "0.8125rem",
                  borderColor: "rgba(0,0,0,0.12)",
                  "&.Mui-selected": {
                    bgcolor: "primary.main",
                    color: "#fff",
                    "&:hover": { bgcolor: "primary.dark" },
                  },
                },
              }}
            >
              <ToggleButton value={true}>Pakiety główne</ToggleButton>
              <ToggleButton value={false}>Wszystkie pakiety</ToggleButton>
            </ToggleButtonGroup>
            <Tooltip title={<PackageKindTooltip />} arrow placement="bottom" enterTouchDelay={0}>
              <IconButton size="small" aria-label="Wyjaśnienie typów pakietów" sx={{ color: "text.secondary" }}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>

          <PackageRegionFilter paramName="region" />
          <TagFiltersMenu />

          <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: "nowrap", alignSelf: { md: "center" } }}>
            <Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
              {props.filteredPackages}
            </Box>{" "}
            pakietów
          </Typography>
        </Stack>
        <PopularFilters
          ecommerceOnly={props.onlyEcommercePackages}
          toggleEcommerceOnly={() => props.setOnlyEcommercePackages(!props.onlyEcommercePackages)}
        />
      </Paper>
      <ActiveFilters
        ecommerceOnly={props.onlyEcommercePackages}
        toggleEcommerceOnly={() => props.setOnlyEcommercePackages(!props.onlyEcommercePackages)}
      />
    </>
  );
}
